var module = angular.module('octopusApp.projects');

module.directive('lifecycleMap', function() {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    templateUrl: 'areas/projects/views/lifecycle_map.html',
    scope: {
      lifecycle: '=',
      environments: '=',
      progression: '='
    },
    link: function(scope, element) {
      scope.$watch("environments", function() {
        scope.environmentsById = _.object(_.pluck(scope.environments, "Id"), scope.environments);
      });

      var empty = [];

      scope.getPhaseCollection = function () {
        if (scope.progression) {
          return scope.progression.Phases;
        } else if (scope.lifecycle) {
          return scope.lifecycle.Phases;
        }
        return empty;
      };

      scope.getSingleDeploymentTarget = function(phase) {
        if (phase.AutomaticDeploymentTargets.length > 0) {
          return phase.AutomaticDeploymentTargets[0];
        } else {
          return phase.OptionalDeploymentTargets[0];
        }
      };

      scope.$watch("progression", function() {
        scope.deployed = {};
        scope.tasks = {};
        scope.warning = {};
        scope.executing = {};
        scope.queued = {};
        scope.progress = {};

        if (!scope.progression) {
          return;
        }

        _.each(scope.progression.Phases, function (phase) {
          var phaseStatus = phase.Progress;
          if (phase.Blocked) {
            phaseStatus = "Blocked";
          }
          scope.progress[phase.Name] = phaseStatus;

          _.each(phase.Deployments, function (deployment) {
            scope.deployed[deployment.Deployment.EnvironmentId] = true;
            scope.tasks[deployment.Deployment.EnvironmentId] = deployment.Task.Id;
            scope.warning[deployment.Deployment.EnvironmentId] = deployment.Task.HasWarningsOrErrors;
            scope.executing[deployment.Deployment.EnvironmentId] = deployment.Task.State !== "Success";
            scope.queued[deployment.Deployment.EnvironmentId] = deployment.Task.State === "Queued";
          });
        });
      });

      scope.envCount = function(phase) {
        return _.union(phase.OptionalDeploymentTargets, phase.AutomaticDeploymentTargets).length;
      };
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/lifecycle_map.js
// module id = 6819805728874068
// module chunks = 1